import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const StyledContact = styled.div`
    color: white;
    align-items: flex-end;
    display: flex;
    flex-direction: column;
`

const StyledContactInfo = styled.div`
    font-size: 0.7rem;
    font-family: ${(props) => props.theme.font.sans};
    color: ${(props) => props.theme.color.grey};
`

const StyledInstagramIcon = styled.div`
    width: 24px;
    height: 24px;
    opacity: 0.7;
    margin-top: 12px;

    &:hover {
        pointer: cursor;
        opacity: 0.9;
    }
`

export default function Contact() {
    return (
        <StyledContact>
            <StyledContactInfo>
                customer.service@kingchildren.com
            </StyledContactInfo>
            <StyledContactInfo>+1 ‪(347) 759-6340‬</StyledContactInfo>
            <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/king.children/"
            >
                <StyledInstagramIcon>
                    <StaticImage
                        alt="Instagram"
                        src="../../images/Icon/instagram-white.png"
                        imgStyle={{ objectFit: "contain" }}
                    />
                </StyledInstagramIcon>
            </a>
        </StyledContact>
    )
}
